
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo and tagline */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-orange-400 bg-clip-text text-transparent mb-4">
              ZimKonnect
            </h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Connecting the Zimbabwean diaspora with their home projects through 
              transparent tracking and trusted local networks.
            </p>
            <p className="text-orange-400 font-semibold text-lg">
              By Zimbabweans. For Zimbabweans.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="hover:text-white transition-colors duration-200">Home</a></li>
              <li><a href="#how-it-works" className="hover:text-white transition-colors duration-200">How It Works</a></li>
              <li><Link to="/blog" className="hover:text-white transition-colors duration-200">Blog</Link></li>
              <li><a href="#join-waitlist" className="hover:text-white transition-colors duration-200">Join Waitlist</a></li>
              <li><a href="#become-supplier" className="hover:text-white transition-colors duration-200">Become a Supplier</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href="mailto:info@zimkonnect.com" className="hover:text-white transition-colors duration-200">
                  info@zimkonnect.com
                </a>
              </div>
              <div>
                <a 
                  href="https://twitter.com/Tapalabszw" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 transition-colors duration-200"
                >
                  Follow us @Tapalabszw
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
            <div className="text-gray-400 text-sm">
              © 2024 ZimKonnect. All rights reserved.
            </div>
            
            {/* Policy Links */}
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
              <Link 
                to="/privacy-policy" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/tos" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link 
                to="/cookies" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Cookie Policy
              </Link>
              <Link 
                to="/security" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Data & Security
              </Link>
              <Link 
                to="/referral-terms" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Referral Terms
              </Link>
              <Link 
                to="/disclaimer" 
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Disclaimer
              </Link>
            </div>

            <div className="text-gray-400 text-sm">
              For questions, contact us at <a href="mailto:info@zimkonnect.com" className="text-orange-400 hover:text-orange-300">info@zimkonnect.com</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
